import { render, staticRenderFns } from "./projectPrices.vue?vue&type=template&id=3be0a1b7&scoped=true"
import script from "./projectPrices.vue?vue&type=script&lang=js"
export * from "./projectPrices.vue?vue&type=script&lang=js"
import style0 from "./projectPrices.vue?vue&type=style&index=0&id=3be0a1b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0a1b7",
  null
  
)

export default component.exports